
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class UtentiProdottiEsperienzeDashboardGrid extends Serenity.EntityGrid<UtentiProdottiEsperienzeDashboardRow, any> {
        protected getColumnsKey() { return UtentiProdottiEsperienzeDashboardColumns.columnsKey; }
        protected getDialogType() { return UtentiProdottiEsperienzeDashboardDialog; }
        protected getIdProperty() { return UtentiProdottiEsperienzeDashboardRow.idProperty; }
        protected getInsertPermission() { return UtentiProdottiEsperienzeDashboardRow.insertPermission; }
        protected getLocalTextPrefix() { return UtentiProdottiEsperienzeDashboardRow.localTextPrefix; }
        protected getService() { return UtentiProdottiEsperienzeDashboardService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected createSlickGrid() {
            this.slickGrid = super.createSlickGrid();

            new Serenity.AutoColumnWidthMixin({
                grid: this,
                autoSizeAllJustOnce: false,
                useExplicitWidths: true,
                ignoreHeaders: 800,
                maxWidth: 800,
                minWidth: 300
            });

            return this.slickGrid;
        }

        protected getSlickOptions(): Slick.GridOptions {
            let opt = super.getSlickOptions();
            //opt.rowHeight = 150;
            return opt;
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 100;
            return opt;
        }

        protected getInitialTitle() {
            return null;
        }

        protected usePager() {
            return true;
        }

        protected createQuickSearchInput() { }

        protected getGridCanLoad() {
            return (this.IdUtenteProdotto > 0);
        }

        protected getColumns() {
            var columns = super.getColumns();

            // Add column
            columns.unshift({
                field: 'Esperienze',
                name: '',
                format: ctx => '<a class="inline-action goto-esperienze" title="Elenco sessioni dell\'esperienza">' +
                    '<i class="fa fa-tasks text-green"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "refresh-button"), 1);

            return buttons;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);

            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented())
                return;

            // get reference to current item
            var item = this.itemAt(row);

            // get reference to clicked element
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('goto-esperienze')) {                    
                    var theDialog = new Gamification.UtentiProdottiEsperienzeListGridDialog({
                        IdUtenteProdotto: item.IdUtenteProdotto,
                        IdProdottoEsperienza: item.IdProdottoEsperienza,
                        IdProdottoEsperienzaNome: item.IdProdottoEsperienzaNome
                    });
                    theDialog.dialogOpen();
                }
            }
        }

        // ///////////////////////////////////////////////////////////////
        private _IdUtenteProdotto: number;

        get IdUtenteProdotto() {
            return this._IdUtenteProdotto;
        }

        set IdUtenteProdotto(value: number) {
            if (this._IdUtenteProdotto != value) {
                this._IdUtenteProdotto = value;
                this.setEquality(UtentiProdottiEsperienzeDashboardRow.Fields.IdUtenteProdotto, value);
                this.refresh();
            }
        }
    }
}